<template>
  <div class="pg-option-add-medical">
    <div class="pg-medical_select">
      <PgSelect
        class="pg-medical_selectInput inputHeight space"
        ref="pgMedical_select"
        v-bind="$attrs"
        popperClass="pg-medical_select-input"
        v-on="$listeners"
        filterable
        initMenuHide
        :remote="true"
        :placeholder="placeholder"
        @change="medicalItemSelect"
        :disabled="disabled"
        v-model="curMedicalItem"
        :source="source"
        :sourceMethod="sourceMethod"
        :sourceParams="requestParams"
      >
        <template #default="{ options, valueKey, labelKey, valueIsObj }">
          <Option
            class="pg-medical_select-option"
            v-for="option in options"
            :key="getValue(option, valueKey)"
            :label="getValue(option, labelKey)"
            :value="valueIsObj ? option : getValue(option, valueKey)"
          >
            <p class="pg-medical_title">{{ getValue(option, labelKey) }}</p>
            <p class="pg-medical_double">
              <span
                v-for="des in optionDescriptionsO"
                :key="des.key"
                :class="[{ blockIm: des.block }]"
                ><label>{{ des.label }}</label
                >{{ getValue(option, des.key) ?? '-' }}</span
              >
            </p>
            <p class="pg-medical_double">
              <span
                v-for="des in optionDescriptionsT"
                :key="des.key"
                :class="[{ blockIm: des.block }]"
                ><label>{{ des.label }}</label
                >{{ getValue(option, des.key) ?? '-' }}</span
              >
            </p>
          </Option>
        </template>
      </PgSelect>
      <PgInput
        ref="pgMedical_numberInput"
        v-if="numberInput"
        placeholder="数量"
        class="pg-medical_number inputHeight space"
        :disabled="disabled"
        @keyup.native.enter="handelAddAfterFunc()"
        v-model="curMedicalItem_num"
      ></PgInput>
      <el-button
        ref="pgMedical_addBtn"
        type="primary"
        icon="el-icon-circle-plus-outline"
        circle
        class="pg-medical_add inputHeight space"
        :disabled="disabled"
        @click="handelAddAfterFunc()"
      ></el-button>
      <span class="pg-medical_huo space">或</span>
      <div class="flex flex-v pg-medical_addOther">
        <el-button
          type="text"
          :disabled="disabled"
          v-if="superAdd"
          @click="handelOtherAddFunc('superAdd')"
          >通过高级查询添加商品</el-button
        >
        <el-button
          type="text"
          :disabled="disabled"
          v-if="templateAdd"
          @click="handelOtherAddFunc('templateAdd')"
          >通过模板添加商品</el-button
        >
        <el-button
          type="text"
          :disabled="disabled"
          v-if="excelAdd"
          @click="handelOtherAddFunc('excelAdd')"
          >通过Excel复制添加商品</el-button
        >
      </div>
    </div>

    <p class="pg-medical_select-data" :class="{ 'pg-medical_select-data--no': !curMedicalItem }">
      <span v-for="des in selectedDescriptions" :key="des.key"
        ><label>{{ des.label }}</label
        ><span v-if="!!curMedicalItem"
          >：{{ `${getValue(curMedicalItem, des.key) ?? '-'}` }}</span
        ></span
      >
    </p>

    <!-- 其他添加方式组件 -->
    <dialogAdd
      v-if="superAdd"
      ref="dialogAddRef"
      v-bind="superAddProps"
      :optionDescriptionsO="optionDescriptionsO"
      :optionDescriptionsT="optionDescriptionsT"
      @input="(data) => handelAddAfterFunc(data, 'superAdd')"
    ></dialogAdd>
    <drawerExcelAdd
      v-if="excelAdd"
      ref="excelAddRef"
      v-bind="excelAdd"
      :onOk="(data) => handelAddAfterFunc(data, 'excelAdd')"
    ></drawerExcelAdd>
    <drawerTemplateAdd
      v-if="templateAdd"
      ref="templateAddRef"
      v-bind="templateAdd"
      @input="(data) => handelAddAfterFunc(data, 'templateAdd')"
    ></drawerTemplateAdd>
  </div>
</template>
<script setup>
// vue
import { computed, ref } from 'vue'
// components
import PgSelect from '../../select/src/basic-select.vue'
import { Option } from 'element-ui'
import dialogAdd from '../components/dialog-add.vue' // 通过高级查询添加商品
import drawerExcelAdd from '../components/drawer-excel-add.vue' // 通过模板添加商品
import drawerTemplateAdd from '../components/drawer-template-add.vue' // 通过Excel复制添加商品
//hook
import { useFlashAddMedical } from '../hook/use-flash-add'
import { useExcelAdd } from '../hook/use-excel-add'
// utils
import { getValueByPath, setValueByPath } from '../../../utils/index'

const props = defineProps({
  optionDescriptions: {
    type: Array,
    default: () => [
      { label: '厂家物料编码：', key: 'number', block: true },
      { label: '医保编码：', key: 'insurance', block: true },
      { label: '编码：', key: 'code', block: false },
      { label: '通用名：', key: 'commonName', block: false },
      { label: '规格型号：', key: 'model', block: true },
      { label: '生产企业：', key: 'manufacturerName', block: false },
      { label: '品牌：', key: 'brand', block: false },
      { label: '单位：', key: 'unit.name', block: true },
    ],
  }, // 下拉列表-描述两排
  selectedDescriptions: {
    type: Array,
    default: () => [
      { label: '厂家物料编码', key: 'number' },
      { label: '医保编码', key: 'insurance' },
      { label: '编码', key: 'code' },
      { label: '通用名', key: 'commonName' },
      { label: '规格型号', key: 'model' },
      { label: '生产企业', key: 'manufacturerName' },
      { label: '品牌', key: 'brand' },
      { label: '单位', key: 'unit.name' },
    ],
  }, // 下拉列表-下方描述
  placeholder: {
    type: String,
    default:
      '厂家物料编码 医保编码 编码 名称 通用名 规格型号  生产企业名称 品牌。多个关键字段，用空格分割',
  }, // 下拉选择input的框内部的placeholder
  disabled: Boolean, // 组件的disabled属性
  // 数量输入框
  numberInput: {
    type: Boolean,
    default: true,
  },
  // 数量属性key，需要添加在选择的对象中
  numberProperty: {
    type: String,
    default: '_inputNumber',
  },
  // 通过高级查询添加商品
  superAdd: {
    type: Object,
    default: null,
  },
  // 通过Excel复制添加商品
  excelAdd: {
    type: Object,
    default: null,
  },
  //通过模板添加商品
  templateAdd: {
    type: Object,
    default: null,
  },
  // 下拉选择配置-主要是因为，下拉选择，跟通过高级查询添加商品使用的是一个链接跟参数，因此在这里接一下
  source: [String, Array],
  sourceMethod: {
    type: String,
    default: 'post',
  },
  requestParams: Object,
})

const emit = defineEmits([])

// 获取公共方法
const { emitComponentData } = useFlashAddMedical(emit)

const getValue = (data, key) => getValueByPath(data, key)

// ------------提前处理一些参数---------------
// 通过高级查询添加商品

const superAddProps = computed(() => {
  if (!props.superAdd) return null
  return {
    ...props.superAdd,
    listUrl: props.source,
    listParams: { parameters: props.requestParams, ...props.superAdd.listParams },
  }
})

// ------------变量配置---------------
// 组件元素Ref
const pgMedical_select = ref(null) //商品下拉选择
const pgMedical_numberInput = ref(null) //数量输入框
const pgMedical_addBtn = ref(null) //原型添加按钮

// 下拉列表-第二排
const optionDescriptionsO = computed(() => {
  return props.optionDescriptions.filter((im) => im.block)
})

// 下拉列表-第三排
const optionDescriptionsT = computed(() => {
  return props.optionDescriptions.filter((im) => !im.block)
})

// 下拉列表-选中的信息
const curMedicalItem = ref(null)
// 数量输入框
const curMedicalItem_num = ref(null)

// 下拉列表-选择变更处理
const medicalItemSelect = (value) => {
  curMedicalItem.value = value

  // 如果有数量，则自动将光标移入数量输入框内的input上
  if (props.numberInput) {
    setTimeout(() => {
      pgMedical_numberInput.value.focus()
    }, 300)
  }
}

// 聚焦下拉框
const focusSelect = () => {
  setTimeout(() => {
    pgMedical_select.value.focus()
  }, 300)
}

// -----------------------------------其他查询方式----------------------------------
const dialogAddRef = ref(null)
const excelAddRef = ref(null)
const templateAddRef = ref(null)

// 高级查询-点击处理函数
const handelOtherAddFunc = (type) => {
  switch (type) {
    case 'superAdd':
      dialogAddRef.value.open()
      break
    case 'templateAdd':
      templateAddRef.value.open()
      break
    case 'excelAdd':
      excelAddRef.value.open()
      break
    default:
      break
  }
}

// 所有添加 都回归一个函数进行处理

const handelAddAfterFunc = (data, type) => {
  let tempData = data ?? curMedicalItem.value
  let parameters = {
    ...props.requestParams?.parameters,
  }
  // 如果有数量输入框，就把数量输入框的数据放入请求中
  if (props.numberInput) setValueByPath(parameters, props.numberProperty, curMedicalItem_num.value)
  // 下拉选择添加
  switch (type) {
    case 'superAdd':
      setValueByPath(
        parameters,
        'codes',
        tempData.map((im) => im.code)
      )
      break
    case 'templateAdd':
      setValueByPath(parameters, 'template_with_amount', tempData.template_with_amount)
      setValueByPath(
        parameters,
        'templateIds',
        tempData.data.map((im) => im.id)
      )
      break
    case 'excelAdd':
      useExcelAdd(props.excelAdd, data)
      parameters = Object.assign(parameters, data.requestData)
      break
    default:
      setValueByPath(parameters, 'codes', [tempData.code])
      break
  }

  // 如果配置了请求 就把请求发出去
  emitComponentData({
    data: tempData, // 传出处理的数据
    originData: type ? data : tempData, // 如果没有type 说明是input 的添加，则直接把数据传出去
    type: type ?? 'selectAdd', //类型默认是selectAdd
    parameters: { ...props.requestParams, parameters },
  })
  curMedicalItem_num.value = null
  curMedicalItem.value = null

  // 只有下拉选择的时候，才聚焦到下拉框上
  if (!type) focusSelect()
}
</script>
<style lang="scss">
@import '../style/option-add-medical.scss';
</style>
